// وصول سريع في الرئيسية إلى الأدوات والتلاوات.
// (المصحف له بطاقته تحت هذا الصف، فلا يتكرر هنا.)

import React from 'react';
import { BookHeart, LayoutGrid, Headphones, HandHeart } from 'lucide-react';

const QUICK = [
  { id: 'tools', label: 'أدوات المسلم', Icon: LayoutGrid },
  { id: 'audio', label: 'التلاوات', Icon: Headphones },
  { id: 'hisn', label: 'حصن المسلم', Icon: HandHeart },
  { id: 'quranDuas', label: 'أدعية القرآن', Icon: BookHeart },
];

/**
 * @param onOpenMushaf(view?)  view: 'audio' للمكتبة الصوتية
 * @param onOpenTools(tool?)   tool: معرّف أداة تُفتح مباشرة
 */
export function YourDay({ onOpenMushaf, onOpenTools }) {
  const go = (id) => {
    if (id === 'audio') onOpenMushaf('audio');
    else onOpenTools(id === 'tools' ? null : id);
  };

  return (
    <nav className="mt-6 grid grid-cols-4 gap-1" aria-label="وصول سريع">
      {QUICK.map(({ id, label, Icon }) => (
        <button key={id} onClick={() => go(id)} className="flex flex-col items-center gap-2 py-2 rounded-md hover:bg-ink/5">
          <span className="w-12 h-12 rounded-full border border-primary/40 text-primary flex items-center justify-center">
            <Icon className="w-5 h-5" aria-hidden="true" />
          </span>
          <span className="text-2xs font-semibold text-ink text-center leading-tight">{label}</span>
        </button>
      ))}
    </nav>
  );
}
